module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    attrs: {
      "withContent": true
    },
    on: {
      "close": function (e) { return _vm.$emit('close', e); }
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$trad.plano.editor.header.help.shortcutList.label))]), _vm._v(" "), _c('ul', _vm._l((Object.keys(_vm.shortcuts)), function(shortcut) {
    return _c('fragment', {
      key: shortcut
    }, [_c('label', [_vm._v(_vm._s(_vm.$trad.plano.editor.header.help.shortcutList[shortcut]))]), _vm._v(" "), _c('li', _vm._l((_vm.shortcuts[shortcut]), function(char, i) {
      return _c('strong', {
        key: i
      }, [_vm._v(_vm._s(char))])
    }))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f7fd273","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/modal/shortcuts.vue
// module id = 3177
// module chunks = 0